import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NewProgressLoader } from "@bca/ui-library";
import { getLoadingScreen } from "../../reducers/loadingScreenSlice";
import {
  StyledLoadingScreen,
  StyledTitle,
  StyledContent,
  StyledSubtitle,
  StyledA,
  StyledTypography,
  StyledBanner,
  StyledBannerText,
} from "./LoadingScreen.styled";

const LoadingScreen = () => {
  const { page_content, loading } = useSelector((state) => state.loadingScreen);

  const { value: languageCode } = useSelector((state) => state.languageOptions);
  const { country_name: countrySelected } = useSelector((state) => state.form);
  const { pageError, showServerErrorMessage } = useSelector(
    (state) => state.errorManagement
  );

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getLoadingScreen(countrySelected, languageCode));
  }, [dispatch, languageCode, countrySelected]);

  return (
    <StyledLoadingScreen>
      {!loading &&
        (showServerErrorMessage ? (
          <StyledTypography>
            Internal server error. We apologise for the inconvenience, we are
            investigating. Please check back in a while. Back to &nbsp;
            <StyledA href="https://www.bca.com">https://www.bca.com.</StyledA>
          </StyledTypography>
        ) : (
          <>
            <NewProgressLoader />
            <StyledTitle>{page_content?.submit_feedback}</StyledTitle>
            <StyledContent>{page_content?.submit_information}</StyledContent>
            <StyledSubtitle>{page_content?.submit_time}</StyledSubtitle>
          </>
        ))}
      {pageError.page === "submit_registration" && pageError.status === 400 && (
        <StyledBanner
          variant="warning"
          displayMode="inline"
          title="Something went wrong"
        >
          <StyledBannerText>Please refresh the page</StyledBannerText>
        </StyledBanner>
      )}
    </StyledLoadingScreen>
  );
};

export default LoadingScreen;
